import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { queryClient } from './api/queryClient';
import '@elladx/design-system/tokens.css';
import '@elladx/design-system/theme.css';
import '@elladx/design-system/portal.css';
import './styles/layout.css';
import './styles/management.css';
import './styles/shipment-workflow.css';
import './styles/bulk-flow.css';
import './styles/settings-workflow.css';
import './styles/print.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>);
